import type { ColDef, IRowNode } from 'ag-grid-community';
import { type BulkManageRow, type BulkManageUpdateFn } from '../types';
import { bulkManageSortFunction } from './bulkManageSortFunction';
import { ProxyCellRenderer, type ProxyCellRendererParams } from './ProxyCellRenderer';
import type { BulkPickerDetailedProxyMetadata } from '../../hooks/useProxyDataQuery';
import { isBulkManageCashRow, isBulkManageFundRow, isBulkManageOptionRow } from '../utils';

const PROXY_COL_MIN_WIDTH = 160;

export const getReturnsProxyColDef = (
  canEditProxies: boolean,
  onUpdate: BulkManageUpdateFn,
  openBulkProxyModal: (row: IRowNode<BulkManageRow>) => void,
): ColDef<BulkManageRow, BulkPickerDetailedProxyMetadata | undefined> => {
  return {
    flex: 2,
    maxWidth: 350,
    minWidth: PROXY_COL_MIN_WIDTH,
    cellRendererSelector: ({ node }) => {
      return (isBulkManageFundRow(node.data) || isBulkManageCashRow(node.data) || isBulkManageOptionRow(node.data)) &&
        !node.group
        ? {
            component: ProxyCellRenderer,
            params: {
              canEditProxies,
              onUpdate,
              openBulkProxyModal,
            } satisfies ProxyCellRendererParams,
          }
        : undefined;
    },
    headerName: 'Returns Proxy',
    sortable: true,
    field: 'fundProxyInfo',
    comparator: bulkManageSortFunction({
      valueGetter: (value) => value?.proxyName,
    }),
  };
};
